import React from "react";
import Allproblem from "./Allproblem";

function Problem() {
  return (
    <>
      <head>
        <title>Problem</title>
      </head>
      <div className="admincontainer">
        <h1>Manhole Problems</h1>
        <Allproblem />
      </div>
    </>
  );
}

export default Problem;
